import { Platform } from 'react-native';

/**
 * Generates ID strings. Types of IDs generated:
 * 1. HTML IDs (if run in the browser)
 * 2. Test IDs
 *
 * @param id The ID string
 */
const generateID = (id?: string) => {
  if (id) {
    return {
      ...Platform.select({
        web: {
          nativeID: id,
        },
      }),
      // Requires React Native 0.64 to work with Android
      testID: `test:id/${id}`,
    };
  }

  return {
    nativeID: undefined,
    testID: undefined,
  };
};

export default generateID;
